<template>
	<div class="packageTour">
		<back-to :title="title" :url="url"></back-to>
		<!-- 顶部 -->
		<section class="packageTour-banner">
			<!-- banner -->
			<van-swipe class="packageTour-banner-swiper" :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item, index) in data_ad_image_array" :key="index">
					<img v-lazy="item.Url" />
				</van-swipe-item>
			</van-swipe>
			<div class="packageTour-banner-main">
				<!-- 搜索 -->
				<div class="banner-main_search" @click="$router.push({path: '/packageSearch',query:{type:type}})">
					<p>出发地、目的地、产品名称</p>
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/index-seach.png" alt="">
				</div>
				<!-- 推荐 -->
				<div class="banner-main_recommend">
					<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/line-mdd.png" alt="">
					<van-swipe :autoplay="3000" class="banner-main_recommend_swiper" :show-indicators="false" vertical>
						<van-swipe-item v-for="(item, index) in data_ad_product_array" :key="index" @click="$router.push({path: '/packageSearch',query:{disArr:item,type:type}})">
							<span class="banner-main_recommend_item">
								<p>{{item.Name}} </p>
								<font>:</font>
								<p v-for="(data, key) in item.City"> {{data.Name}}、</p>
							</span>
						</van-swipe-item>
					</van-swipe>
				</div>
				<!-- 地址 -->
				<div class="banner-main_address">
					<img v-for="(item, index) in type == 1? data_ad_product_array:desCurren" v-lazy="item.Url" @click="$router.push({path: '/packageSearch',query:{disArr:item,type:type}})"/>
				</div>
				<!-- 查看更多 -->
				<div class="banner-main_more" @click="$router.push({path: '/more',query:{type:type}})">查看更多目的地</div>
			</div>
		</section>
		<section class="packageTour-jumpDz" v-if="type == 1">
			<img :src="'https://sweetour-pic.obs.myhwclouds.com/add-gtdz.png?v='+Math.random()" alt="">
		</section>
		<!-- 列表 -->
		<section class="packageTour-List">
			<div class="packageTour-List_hot">
				<span>热门推荐</span>
				<span @click="$router.push({path: '/packageSearch',query:{type:type}})">更多></span>
			</div>
			<List :tab_menu_array_index="1" ref="changList"></List>
		</section>
	</div>
</template>

<script>
	import List from '@/components/List.vue'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'packageTour',
		components: {
			BackTo,
			List
		},
		data() {
			return {
				url:"/",
				data_ad_image_array: [],
				seachValue: '',
				endCity: '',
				theme: '',
				pageIndex: 1,
				data_ad_product_array: [],
				desCurren:[],
				title: '',
				type: 1 //1国内 2出境
			}
		},
		created() {
			this.title = this.$route.query.title
			this.type = this.$route.query.type
		},
		mounted() {
			this.getBanner()
			this.getRecommend()
			this.$nextTick(() => {
				if(this.type == 2){
					this.$refs.changList.tourType = true
				}
				this.$refs.changList.page = 1
				this.$refs.changList.connect_ProductList()
			});
		},
		methods: {
			getRecommend() {
				var data = {
					State: this.type == 1 ? 0 : 1, // 0国内 1国外
					Count: 13 // 多少条
				}
				this.$post(
					this.$apiWebsiteSweet + '/api/GetGTLine', data
				).then(res => {
					if (this.type == 1) {
						this.data_ad_product_array = res.GN.slice(1, 13)
					} else {
						this.data_ad_product_array = res.GW
						this.desCurren = res.GW[0].City.slice(0, 12)
					}
				})
			},
			getBanner() {
				var data = {
					"Search": this.seachValue, // 搜索框内容
					"StartCity": 0, // 出发地
					"EndCity": this.endCity, // 目的地
					"Theme": this.theme, // 精选主题
					"Sort": 0, // 排序
					"pageIndex": this.pageIndex,
					"pageSize": 10,
					"destinationCount": 8, // 地区条数
					"themeCount": 4, // 精选条数
				}
				if (this.type == 1) {
					// 国内跟团
					data.Id = 6592
					this.$post(
						this.$apiWebsiteSweet + '/api/Applets_GNTeam', data
					).then(res => {
						this.data_ad_image_array = res.FreeBanners
					})
				} else {
					// 出境跟团
					data.Id = 6617
					this.$post(
						this.$apiWebsiteSweet + '/api/Applets_GWTeam', data
					).then(res => {
						this.data_ad_image_array = res.FreeBanners
					})
				}
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		}
	}
</script>

<style>
	.packageTour-banner {
		width: 100%;
	}

	.packageTour-banner-swiper,
	.packageTour-banner-swiper img {
		width: 100%;
		height: 375px;
	}

	.packageTour-banner-swiper .van-swipe__indicator {
		margin-bottom: 20px;
	}

	.packageTour-banner-main {
		position: relative;
		top: -30px;
		z-index: 2;
		background: #fff;
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
		padding: 30px;
		box-sizing: border-box;
	}

	.banner-main_search {
		display: flex;
		align-items: center;
		justify-content: space-between;
		border: 1px #ff6d00 solid;
		height: 70px;
		border-radius: 36px;
		display: flex;
		padding: 0 36px;
		font-size: 26px;
		color: #ccc;
	}

	.banner-main_search img {
		width: 28px;
		height: 28px;
	}

	.banner-main_recommend {
		width: 100%;
		display: flex;
		height: 70px;
		background: #f6f6f6;
		border-radius: 7px;
		align-items: center;
		padding: 0 20px;
		box-sizing: border-box;
		margin-top: 20px;
	}

	.banner-main_recommend img {
		height: 34px;
		width: 118px;
	}

	.banner-main_recommend_swiper {
		height: 38px;
		width: 100%;
	}

	.banner-main_recommend_item {
		display: flex;
		align-items: center;
		height: 38px;
		padding-left: 20px;
		width: 100%;
		box-sizing: border-box;
		font-size: 26px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.banner-main_recommend_item font {
		padding: 0 7px 0 4px;
	}

	.banner-main_recommend .van-swipe-item:nth-child(1n) .banner-main_recommend_item {
		color: #b34bff !important;
	}

	.banner-main_recommend .van-swipe-item:nth-child(2n) .banner-main_recommend_item {
		color: #ff6c43 !important;
	}

	.banner-main_recommend .van-swipe-item:nth-child(3n) .banner-main_recommend_item {
		color: #33a727 !important;
	}

	.banner-main_recommend .van-swipe-item:nth-child(4n) .banner-main_recommend_item {
		color: #6467ee !important;
	}

	.banner-main_address {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 26px;
	}

	.banner-main_address img {
		width: 218px;
		height: 146px;
		border-radius: 10px;
		margin-bottom: 20px;
	}

	.banner-main_more {
		height: 80px;
		width: 100%;
		background: #f7f7f7;
		color: #ff6d00;
		font-size: 26px;
		line-height: 80px;
		border-radius: 10px;
		text-align: center;
		margin-top: 20px;
	}

	.packageTour-jumpDz {
		height: 98px;
		width: 100%;
		padding: 0 30px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.packageTour-jumpDz img {
		height: 100%;
		width: 100%;
	}

	.packageTour-List {
		width: 100%;
	}

	.packageTour-List_hot {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 30px;
		font-size: 32px;
		font-weight: bold;
	}

	.packageTour-List_hot span:last-child {
		color: #666;
		font-size: 26px;
	}
</style>
